import BaseService from '@/features/BaseService';

export default class RoleService extends BaseService {

  static ADMIN = 'admin';
  static ANALISTA = 'analista';
  static ADMIN_CLIENTE = 'admin_cliente';
  static USUARIO_CLIENTE = 'usuario_cliente';
  static MASTER = 'master';

  constructor() {
    super('roles');
  }
}



// WEBPACK FOOTER //
// ./src/features/role/RoleService.js